var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-map_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13V11H16V13H13V16H11V13H8V11H11V8Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.62C21 18.85 20.85 19.03 20.64 19.1L15 21L9 18.9L3.66 20.97L3.5 21C3.22 21 3 20.78 3 20.5V5.38C3 5.15 3.15 4.97 3.36 4.9L9 3L15 5.1L20.34 3.03L20.5 3C20.78 3 21 3.22 21 3.5V18.62ZM19 17.542L15.0124 18.8854L8.96469 16.7687L5 18.3056V6.45796L8.98759 5.11462L15.0353 7.23132L19 5.69445V17.542Z",
    fill: "#868CA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMap);
export default __webpack_public_path__ + "static/media/add-map.bf156ebe71822cc09689f2033346fea4.svg";
export { ForwardRef as ReactComponent };